import React from "react";
import { Link } from "react-router-dom";

const MyDashboardQuickActions = () => {
  return (
    <div className="quick__actions__container">
      <div className="heading__container">
        <h4 className="heading">Quick Access</h4>
      </div>
      <div className="cards__container">
        <div className="action__card">
          <Link className="quick__actions__link" to={`/calendar`}>
            <div className="icon__container">
              <span className="pi pi-calendar"></span>
            </div>
            <p className="card__name">My Calendar</p>
          </Link>
        </div>
        <div className="action__card">
          <Link className="quick__actions__link" to={`/entities`}>
            <div className="icon__container">
              <span className="pi pi-globe"></span>
            </div>
            <p className="card__name">Entities Under Management</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MyDashboardQuickActions;
